import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 8C13.383 8 8 13.383 8 20C8 26.617 13.383 32 20 32C26.617 32 32 26.617 32 20C32 13.383 26.617 8 20 8ZM22.658 26.284C21.997 26.544 19.706 27.638 18.386 26.475C17.992 26.129 17.796 25.69 17.796 25.157C17.796 24.159 18.124 23.289 18.715 21.2C18.819 20.805 18.946 20.293 18.946 19.887C18.946 19.186 18.68 19 17.959 19C17.607 19 17.217 19.125 16.864 19.257L17.059 18.458C17.846 18.138 18.834 17.748 19.68 17.748C20.949 17.748 21.883 18.381 21.883 19.585C21.883 19.932 21.823 20.54 21.697 20.96L20.967 23.542C20.816 24.064 20.543 25.215 20.966 25.556C21.382 25.893 22.367 25.714 22.853 25.485L22.658 26.284ZM21.452 16C20.624 16 19.952 15.328 19.952 14.5C19.952 13.672 20.624 13 21.452 13C22.28 13 22.952 13.672 22.952 14.5C22.952 15.328 22.28 16 21.452 16Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
